/**
 * Header section of dashboard page
 */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { media, LIGHTEST_GRAY } from '../styles'

const Wrapper = styled.div`
  ${media.small`height: 75px; font-size: 20px;`}
  ${media.huge`height: 75px; font-size: 26px;`}

  background: #fff;
  border-bottom: 1px solid ${LIGHTEST_GRAY};
`
const Container = styled.div`
  height: 100%;
  width: 100%;
  box-shadow: 0 1px 5px 0 rgba(41, 85, 115, 0.21);

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  overflow: hidden;
  background-color: #fff;
`
const LeftNav = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
`
const RightNav = styled.div`
  padding-right: 30px;

  display: flex;
  flex-direction: row;
  align-items: center;
`

class HeaderLayout extends Component {
  render () {
    return (
      <Wrapper>
        <Container>
          <LeftNav>
            {this.props.leftNav}
          </LeftNav>
          <RightNav>
            {this.props.rightNav}
          </RightNav>
        </Container>
      </Wrapper>
    )
  }
}

HeaderLayout.propTypes = {
  leftNav: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]),
  rightNav: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]),
}

export default HeaderLayout



// WEBPACK FOOTER //
// ./src/components/shared/HeaderLayout.js